"use client";

import React, { useEffect, useRef, useState } from "react";

import { useSearchContext } from "shared/contexts/SearchContext";
import { GuestSelectorDropdown } from "Components/molecules/GuestSelectorDropdown";
import {
  ArrowDown,
  GuestSelectorWrapper,
  InputContent,
  InputWrapper,
} from "./styles";

import { ReactComponent as AdultsSvg } from "assets/svgs/adults.svg";
import { ReactComponent as BabiesSvg } from "assets/svgs/babies.svg";
import { ReactComponent as ChildrenSvg } from "assets/svgs/children.svg";
import { ReactComponent as DownChevron } from "assets/svgs/down-chevron.svg";

import { GuestSelectorModal } from "../../GuestSelectorModal";

export const GuestSelectorWithInputMobile: React.FC = () => {
  const { searchState, setAdults, setChildren, setBabies } = useSearchContext();
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const wrapperRef = useRef<HTMLDivElement>(null);

  const toggleDropdown = () => {
    setIsDropdownVisible((prev) => !prev);
  };

  const getGestLabel = (guestCount: number, guestType: string) => {
    if (guestCount > 0) {
      const guestLabel = `${guestType !== "Adulto" ? ", " : ""}${guestCount} ${guestType}${guestCount > 1 ? "s" : ""}`;
      return guestLabel;
    } else {
      return null;
    }
  };

  return (
    <GuestSelectorWrapper ref={wrapperRef}>
      <InputWrapper
        onClick={toggleDropdown}
        aria-label="Selecione os hóspedes"
        aria-expanded={isDropdownVisible}
      >
        <InputContent>
          <AdultsSvg />
          <span>
            {getGestLabel(searchState.adults, "Adulto")}
            {getGestLabel(searchState.children, "Adolescente")}
            {getGestLabel(searchState.babies, "Criança")}
          </span>
        </InputContent>
        <ArrowDown isOpen={isDropdownVisible}>
          <DownChevron />
        </ArrowDown>
      </InputWrapper>

      {isDropdownVisible && (
        <GuestSelectorModal
          isVisibleModal={isDropdownVisible}
          onClose={() => {
            setIsDropdownVisible(false);
          }}
        />
      )}
    </GuestSelectorWrapper>
  );
};
